(function () {
  'use strict';

  var PREFIX = 'kinship_';
  var MAX_QUEUE = 50;
  var queue = [];
  var sentOnce = Object.create(null);
  var recentSent = Object.create(null);

  function clarityReady() {
    return typeof window.clarity === 'function';
  }

  function safeString(value) {
    if (value == null) return '';
    return String(value).replace(/Variant sold out or unavailable/gi, '').replace(/[\r\n\t]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function getMeta() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  }

  function getPageType() {
    var meta = getMeta();
    if (meta.page && meta.page.pageType) {
      var metaType = String(meta.page.pageType).toLowerCase();
      if (metaType.indexOf('search') !== -1) return 'search';
      if (metaType.indexOf('collection') !== -1) return 'collection';
      if (metaType.indexOf('product') !== -1) return 'product';
      if (metaType.indexOf('cart') !== -1) return 'cart';
      return meta.page.pageType;
    }
    var path = window.location.pathname;
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/search') === 0) return 'search';
    if (path === '/' || path === '') return 'home';
    return 'page';
  }

  function pathHandle(prefix) {
    var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
    var marker = '/' + prefix + '/';
    var index = path.indexOf(marker);
    if (index === -1) return '';
    return decodeURIComponent(path.slice(index + marker.length).split('/')[0] || '');
  }

  function baseTags(extra) {
    var meta = getMeta();
    var product = meta.product || {};
    var tags = {
      page_type: getPageType(),
      product_handle: product.handle || pathHandle('products'),
      product_vendor: product.vendor || '',
      product_type: product.type || '',
      collection_handle: pathHandle('collections'),
      currency: meta.currency || '',
      theme_name: window.Shopify && window.Shopify.theme ? window.Shopify.theme.name : ''
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        tags[key] = extra[key];
      });
    }
    return tags;
  }

  function setTags(tags) {
    if (!clarityReady()) return false;
    Object.keys(tags || {}).forEach(function (key) {
      var value = safeString(tags[key]);
      if (value) window.clarity('set', key, value);
    });
    return true;
  }

  function dispatchDebug(eventName, tags) {
    window.dispatchEvent(new CustomEvent('kinship:clarity-event', {
      detail: { event: eventName, tags: tags || {}, clarity_ready: clarityReady() }
    }));
  }

  function send(eventName, tags, options) {
    if (!eventName) return;
    var fullName = eventName.indexOf(PREFIX) === 0 ? eventName : PREFIX + eventName;
    var now = Date.now();
    if (options && options.dedupeMs) {
      if (recentSent[fullName] && now - recentSent[fullName] < options.dedupeMs) return;
      recentSent[fullName] = now;
    }

    var payload = baseTags(tags);
    var key = fullName + ':' + JSON.stringify(payload);

    if (options && options.once && sentOnce[key]) return;
    if (options && options.once) sentOnce[key] = true;

    dispatchDebug(fullName, payload);

    if (!clarityReady()) {
      if (queue.length < MAX_QUEUE) queue.push({ eventName: fullName, tags: payload });
      return;
    }

    setTags(payload);
    window.clarity('event', fullName);
  }

  function flushQueue() {
    if (!clarityReady() || !queue.length) return;
    var pending = queue.splice(0, queue.length);
    pending.forEach(function (item) {
      setTags(item.tags);
      window.clarity('event', item.eventName);
    });
  }

  function textMatches(element, pattern) {
    var text = '';
    if (element) {
      text = [
        element.getAttribute('name'),
        element.getAttribute('aria-label'),
        element.getAttribute('data-option-name'),
        element.getAttribute('data-name'),
        element.getAttribute('title'),
        element.id,
        element.className,
        element.textContent
      ].join(' ');
    }
    return pattern.test(text || '');
  }

  function closestLinkOrButton(target) {
    return target && target.closest ? target.closest('a, button, label, input[type="submit"], [role="button"]') : null;
  }

  function initPageViewEvents() {
    var type = getPageType();
    if (type === 'product') send('pdp_view', {}, { once: true });
    if (type === 'cart') send('cart_viewed', {}, { once: true });
    if (type === 'search') send('search_used', { search_source: 'results_page' }, { once: true });
  }

  function initSubmitEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      var action = form.getAttribute('action') || '';
      var text = form.textContent || '';

      if (/\/cart\/add/i.test(action)) {
        send('add_to_cart', { interaction_surface: 'product_form' }, { dedupeMs: 3000 });
      }

      if (/\/search/i.test(action) || form.querySelector('input[name="q"], input[type="search"]')) {
        send('search_used', { search_source: 'search_form' });
      }

      if (/contact/i.test(action) && form.querySelector('input[type="email"]')) {
        send('newsletter_signup', { interaction_surface: 'newsletter_form' });
      } else if (/newsletter|subscribe|email sign/i.test(text) && form.querySelector('input[type="email"]')) {
        send('newsletter_signup', { interaction_surface: 'newsletter_form' });
      }
    }, true);
  }

  function initChangeEvents() {
    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el || !el.matches) return;
      var name = el.getAttribute('name') || '';

      if (/size/i.test(name) || textMatches(el, /size/i)) {
        send('size_selected', { interaction_surface: 'variant_selector', selected_size: el.value || 'selected' }, { dedupeMs: 1500 });
        return;
      }

      if (/filter\.|filter|sort_by/i.test(name) || textMatches(el, /filter|sort/i)) {
        send('filter_used', { interaction_surface: /sort/i.test(name) ? 'sort_control' : 'filter_control' });
      }
    }, true);
  }

  function initClickEvents() {
    document.addEventListener('click', function (event) {
      var control = closestLinkOrButton(event.target);
      if (!control) return;
      var href = control.getAttribute('href') || '';
      var text = safeString(control.getAttribute('title') || control.value || control.getAttribute('aria-label') || control.textContent);
      var inFooter = !!control.closest('footer, .footer, [id*="footer"], [class*="footer"]');

      if (/\/cart(\?|$|\/)/i.test(href)) {
        send('cart_viewed', { interaction_surface: 'cart_link' });
      }

      if (/checkout/i.test(href) || /checkout/i.test(text) || control.name === 'checkout') {
        send('checkout_intent', { interaction_surface: inFooter ? 'footer' : 'cart_or_drawer' });
      }

      if (/filter|facet|sort/i.test(href) || textMatches(control, /filter|sort/i)) {
        send('filter_used', { interaction_surface: 'filter_click' });
      }

      if (textMatches(control, /\b(size|eu|us|it|xs|s|m|l|xl|xxl|one size|\d{2})\b/i)) {
        var picker = control.closest('variant-selects, variant-radios, fieldset, .product-form__input, [class*="variant"], [class*="size"]');
        var pickerText = picker ? picker.textContent || '' : '';
        if (/size|eu|us|it|one size/i.test(pickerText) || /\b(eu|us|it|one size|\d{2})\b/i.test(text)) {
          send('size_selected', { interaction_surface: 'variant_selector', selected_size: text || 'selected' }, { dedupeMs: 1500 });
        }
      }

      if (inFooter && /\/(policies|pages)\//i.test(href)) {
        send('footer_policy_click', { policy_path: new URL(href, window.location.origin).pathname });
      }
    }, true);
  }

  function initCartApiSignal() {
    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;
    window.fetch = function () {
      var resource = arguments[0];
      var url = typeof resource === 'string' ? resource : resource && resource.url;
      var result = originalFetch.apply(this, arguments);
      if (url && /\/cart\/add(\.js)?/i.test(url)) {
        Promise.resolve(result).then(function (response) {
          if (response && response.ok) send('add_to_cart', { interaction_surface: 'cart_add_fetch' }, { dedupeMs: 3000 });
        }).catch(function () {});
      }
      return result;
    };
  }

  function init() {
    window.KinshipClarityEvents = { send: send, flush: flushQueue, version: '2026-05-27' };
    initPageViewEvents();
    initSubmitEvents();
    initChangeEvents();
    initClickEvents();
    initCartApiSignal();
    setInterval(flushQueue, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
